'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoFill = undefined;
var _updateForm = require('@marmalade/form/lib/actions/update-form');
var _react = require('react');
var _reactRedux = require('react-redux');
var _reactRouter = require('react-router');
var _addressLookup = require('./address-lookup');
var _addressLookup2 = _interopRequireDefault(_addressLookup);
var _values = require('./values');
var _vehicleLookup = require('./vehicle-lookup');
var _vehicleLookup2 = _interopRequireDefault(_vehicleLookup);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getBlankErrors = function getBlankErrors(fields) {
  var fieldNames = Object.keys(fields);
  var errors = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;
  try {
    for (var _iterator = fieldNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var fieldName = _step.value;
      errors[fieldName] = '';
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return errors;
};
var autoFill = function autoFill(setForm) {
  var stages = [{
    name: 'newBusinessStage2',
    state: {
      values: (0, _values.getStage2values)(),
      addressLookup: _addressLookup2.default
    }
  }, {
    name: 'newBusinessStage3',
    state: {
      values: _values.stage3values,
      vehicleLookup: _vehicleLookup2.default
    }
  }, {
    name: 'newBusinessStage4',
    state: {
      values: _values.stage4values
    }
  }];
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;
  try {
    for (var _iterator2 = stages[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _ref = _step2.value;
      var name = _ref.name,
        state = _ref.state;
      setForm(name, Object.assign({}, state, {
        errors: getBlankErrors(state.values)
      }));
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
};
var AutoFillComponent = function AutoFillComponent(_ref2) {
  var location = _ref2.location,
    populateForm = _ref2.populateForm;
  (0, _react.useEffect)(function () {
    if (location.search === '?auto') {
      autoFill(populateForm);
    }
  }, [location.search]);
  return null;
};
var AutoFill = exports.AutoFill = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(null, {
  populateForm: _updateForm.populateForm
})(AutoFillComponent));